import React from 'react'
import { Router, Link, Route, Switch } from 'react-static'
import { hot } from 'react-hot-loader'
import Helmet from 'react-helmet'
import Robot from 'components/Robot'

import Home from 'containers/Home'
import About from 'containers/About'
import Blog from 'containers/Blog'
import Post from 'containers/Post'
import NotFound from 'containers/404'

import './app.css'

const Header = () => (
  <Helmet>
      <meta http-equiv="origin-trial" data-feature="WebVR (For Chrome M62+)" data-expires="2018-03-29" content="AgzvTzuqV1UE0hwz8Xn0cN1kAWly9xRwnfU+KUpHH18t/jr+NhIBYdwuiR7iGHkyYbxWATskJVC1V2pOc0Qg9AQAAABXeyJvcmlnaW4iOiJodHRwczovL21hc3NpdmVyb2JvdC5jby51azo0NDMiLCJmZWF0dXJlIjoiV2ViVlIxLjFNNjIiLCJleHBpcnkiOjE1MjIzNjM0MTN9" />

      <meta name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=no" />

      <link rel="apple-touch-icon" sizes="57x57" href="/favicon/apple-icon-57x57.png" />
      <link rel="apple-touch-icon" sizes="60x60" href="/favicon/apple-icon-60x60.png" />
      <link rel="apple-touch-icon" sizes="72x72" href="/favicon/apple-icon-72x72.png" />
      <link rel="apple-touch-icon" sizes="76x76" href="/favicon/apple-icon-76x76.png" />
      <link rel="apple-touch-icon" sizes="114x114" href="/favicon/apple-icon-114x114.png" />
      <link rel="apple-touch-icon" sizes="120x120" href="/favicon/apple-icon-120x120.png" />
      <link rel="apple-touch-icon" sizes="144x144" href="/favicon/apple-icon-144x144.png" />
      <link rel="apple-touch-icon" sizes="152x152" href="/favicon/apple-icon-152x152.png" />
      <link rel="apple-touch-icon" sizes="180x180" href="/favicon/apple-icon-180x180.png" />
      <link rel="icon" type="image/png" sizes="192x192"  href="/favicon/android-icon-192x192.png" />
      <link rel="icon" type="image/png" sizes="32x32" href="/favicon/favicon-32x32.png" />
      <link rel="icon" type="image/png" sizes="96x96" href="/favicon/favicon-96x96.png" />
      <link rel="icon" type="image/png" sizes="16x16" href="/favicon/favicon-16x16.png" />
      <link rel="manifest" href="/favicon/manifest.json" />
      <meta name="msapplication-TileColor" content="#ffffff" />
      <meta name="msapplication-TileImage" content="/favicon/ms-icon-144x144.png" />
      <meta name="theme-color" content="#ffffff" />

      <link rel="alternate" type="application/rss+xml" title="Massive Robot" href="/rss" />
    </Helmet>
)

const App = () => {
  return (
    <div>
      <Header />
      <Router>
        <Robot>
          <div id="main">
            <Switch>
              <Route exact path="/" component={Home} />
              <Route path="/about" component={About} />
              <Route exact path="/blog" component={Blog} />
              <Route path="/blog/posts/*" component={Post} />
              <Route path="/blog/*" component={Blog} />
              <Route component={NotFound} />
            </Switch>
          </div>
          </Robot>
      </Router>
    </div>
  )
}

export default hot(module)(App)



// WEBPACK FOOTER //
// /opt/build/repo/src/App.js